<div class="flex-row field-input">
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Maak een keuze"
      [(ngModel)]="_value.value"
      (ngModelChange)="onBooleanValueChanged()"
    >
      <mat-option [value]="null">Niet ingevuld</mat-option>
      <mat-option [value]="true">Ja</mat-option>
      <mat-option [value]="false">Nee</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div *ngIf="_value && _value.value === true" class="flex-row field-input">
  <mat-form-field appearance="outline">
    <input matInput [(ngModel)]="_value.description" />
  </mat-form-field>
</div>
